/**
 * Shared Secret Sale session reader for PLP UI + floating return.
 * Storage keys match smilodox-secret-sale-gate.js — never rewrite sessionEnd here.
 */
(function (window) {
  "use strict";

  var STORAGE_NS = "smilodox:secret-sale:";
  var DEFAULT_CAMPAIGN_KEY = "secret-sale-2026-10";
  var EVENT = "smilodox:secret-sale:session";
  var HANDLES = ["secret-sale", "secret-sale-damen", "secret-sale-herren"];

  function config() {
    return window.SmilodoxSecretSaleConfig || {};
  }

  function campaignKey(override) {
    var key = String(override || config().campaignKey || DEFAULT_CAMPAIGN_KEY).trim();
    return key || DEFAULT_CAMPAIGN_KEY;
  }

  function sessionStorageKey(key) {
    return STORAGE_NS + "session:" + campaignKey(key);
  }

  function expiryStorageKey(key) {
    return STORAGE_NS + "expires-at:" + campaignKey(key);
  }

  function readRecord(key) {
    try {
      var raw = window.localStorage.getItem(sessionStorageKey(key));
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      return parsed && typeof parsed === "object" ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  function readExpiry(key) {
    try {
      var value = parseInt(window.localStorage.getItem(expiryStorageKey(key)) || "0", 10);
      return Number.isFinite(value) ? value : 0;
    } catch (e) {
      return 0;
    }
  }

  function getActive(key) {
    var resolvedKey = campaignKey(key);
    var record = readRecord(resolvedKey);
    if (!record || !record.code) return null;
    var expiry = readExpiry(resolvedKey) || parseInt(record.sessionEnd || 0, 10) || 0;
    if (!expiry || expiry <= Date.now()) return null;
    var percent = parseInt(record.percent, 10);
    if (!Number.isFinite(percent) || percent < 1) percent = 0;
    return {
      campaignKey: resolvedKey,
      code: String(record.code || "").toUpperCase(),
      percent: percent,
      type: record.type || "",
      source: record.source || "",
      displayName: record.display_name || "",
      sessionEnd: expiry,
      remainingMs: Math.max(0, expiry - Date.now()),
      lastCollectionHandle: normalizeHandle(record.lastCollectionHandle) || "secret-sale",
      record: record,
    };
  }

  function normalizeHandle(handle) {
    var value = String(handle || "")
      .trim()
      .replace(/^\/+|\/+$/g, "")
      .toLowerCase();
    if (value.indexOf("collections/") === 0) value = value.slice("collections/".length);
    return HANDLES.indexOf(value) !== -1 ? value : "";
  }

  function touchLastCollection(handle, key) {
    var normalized = normalizeHandle(handle);
    if (!normalized) return false;
    var active = getActive(key);
    if (!active || !active.record) return false;
    if (normalizeHandle(active.record.lastCollectionHandle) === normalized) return true;
    // Preserve sessionEnd / expiry — only update last visited collection.
    var next = Object.assign({}, active.record, { lastCollectionHandle: normalized });
    try {
      window.localStorage.setItem(sessionStorageKey(key), JSON.stringify(next));
      emit({ type: "touch", handle: normalized });
      return true;
    } catch (e) {
      return false;
    }
  }

  function formatClock(ms) {
    var safe = Math.max(0, Math.floor(Number(ms) || 0));
    var totalSec = Math.floor(safe / 1000);
    var mm = Math.floor(totalSec / 60);
    var ss = totalSec % 60;
    return {
      mm: String(mm).padStart(2, "0"),
      ss: String(ss).padStart(2, "0"),
      totalSec: totalSec,
    };
  }

  function collectionUrl(handle) {
    var normalized = normalizeHandle(handle) || "secret-sale";
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    if (root.slice(-1) !== "/") root += "/";
    return root + "collections/" + normalized;
  }

  function emit(detail) {
    try {
      window.dispatchEvent(new CustomEvent(EVENT, { detail: detail || {} }));
    } catch (e) {}
  }

  function onChange(callback) {
    if (typeof callback !== "function") return function () {};
    var handler = function () {
      callback(getActive());
    };
    var storageHandler = function (event) {
      if (!event || !event.key || String(event.key).indexOf(STORAGE_NS) !== 0) return;
      handler();
    };
    var visibilityHandler = function () {
      if (document.visibilityState === "hidden") return;
      handler();
    };
    window.addEventListener(EVENT, handler);
    window.addEventListener("storage", storageHandler);
    document.addEventListener("visibilitychange", visibilityHandler);
    return function () {
      window.removeEventListener(EVENT, handler);
      window.removeEventListener("storage", storageHandler);
      document.removeEventListener("visibilitychange", visibilityHandler);
    };
  }

  window.SmilodoxSecretSaleSession = {
    STORAGE_NS: STORAGE_NS,
    EVENT: EVENT,
    HANDLES: HANDLES.slice(),
    campaignKey: campaignKey,
    getActive: getActive,
    readRecord: readRecord,
    readExpiry: readExpiry,
    touchLastCollection: touchLastCollection,
    formatClock: formatClock,
    collectionUrl: collectionUrl,
    normalizeHandle: normalizeHandle,
    isSecretSaleHandle: function (handle) {
      return !!normalizeHandle(handle);
    },
    onChange: onChange,
    emit: emit,
  };
})(window);
